import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { SignUpClientFormData } from "../types";

export const CompanyField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<SignUpClientFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">Company</Typography>
      <TextInput className="w-full" hasError={!!errors.company} placeholder="Enter Company Name" maxLength={100} {...register("company")} />
      <Typography variant="small" className="text-neutral-dark-gray">
        Optional
      </Typography>
      <ErrorMessage errors={errors} name="company" />
    </div>
  );
};
